<script setup>
import AuditLog from "@/components/log/AuditLog.vue";
import { useLogStore } from "@/store/modules/log.js";

const logStore = useLogStore();
</script>

<template>
  <!-- singleton -->
  <AuditLog :ref="logStore.auditLog.getAuditLogRef" />
</template>

<style lang="scss" scoped></style>
